import React from 'react';
import {
    DIALOG_FILTER, ENTITIES,
    INPUT_PHRASES,
    OUTPUT_PHRASES, PATTERN_FILTER,
    PATTERNHASH_FILTER, PHRASE_FILTER,
    UNRECOGNIZED_PHRASES,
    ENTITY_TYPE_FILTER,
    ENTITY_VALUE_FILTER
} from '../../../../const/logFilters';
import AnalyticIntentsTile from '../AnalyticsTile/AnalyticIntentsTile';
import { ONE_DAY, ONE_WEEK } from '../../../../const/periodRanges';
import _ from 'lodash';
import moment from 'moment';
import AnalyticsFilter from '../AnalyticsFilter/AnalyticsFilter';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import * as actions from '../../../../redux/projectAnalytics/actions.projectAnalytics';
import * as projectActions from '../../../../redux/projects/actions.projects';
import * as scriptEditorActions from '../../../../redux/scriptEditor/actions.scriptEditor';
import { connect } from 'react-redux';
import AnalyticUsersTile from '../AnalyticsTile/AnalyticUsersTile';
import AnalyticDialogsTile from '../AnalyticsTile/AnalyticDialogsTile';
import AnalyticsLocationTile from '../AnalyticsTile/AnalyticsLocationTile';
import AnalyticPatternFlowTile from '../AnalyticsTile/AnalyticPatternFlowTile';
import AnalyticPatternTile from '../AnalyticsTile/AnalyticPatternTile';
import AnalyticsMicSessionsBarChartTile from '../AnalyticsTile/AnalyticsMicSessionsBarChartTile';
import AnalyticsUserSessionsBarChartTile from '../AnalyticsTile/AnalyticsUserSessionsBarChartTile';
import AnalyticsVoiceInteractionsBarChartTile from '../AnalyticsTile/AnalyticsVoiceInteractionsBarChartTile';

const GOOGLE_MAPS_SCRIPT_LOCATION = process.env.GOOGLE_MAPS_SCRIPT_LOCATION;

function isLocationChartAvailable(features) {
    if (features?.analytics?.charts?.googleLocation?.enabled === true) {
        if (GOOGLE_MAPS_SCRIPT_LOCATION &&
            _.isString(GOOGLE_MAPS_SCRIPT_LOCATION)) {
            return true;
        } else {
            console.warn('Specifiy google map env variables for LocationChart');
        }
    }

    return false;
}

function isSessionsChartAvailable(features) {
    if (features?.analytics?.charts?.sessions?.enabled === true) {
        return true;
    }

    return false;
}

function isVoiceInteractionsChartAvailable(features) {
    if (features?.analytics?.charts?.voiceInteractions?.enabled === true) {
        return true;
    }

    return false;
}

class AnalyticColumnComponent extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            filterUpdateTs: null,
        };
    }

    getRangeDates = (minDate, maxDate, analyticsRange) => {
        const format = 'YYYY-MM-DD';
        let fromDate,
            toDate;
        if (analyticsRange === ONE_DAY) {
            fromDate = moment(minDate).format(format);
            toDate = moment(maxDate).format(format);
        } else if (analyticsRange === ONE_WEEK) {
            fromDate = moment(minDate).startOf('isoWeek').format(format);
            toDate = moment(maxDate).endOf('isoWeek').format(format);
        } else {
            fromDate = moment(minDate).startOf('month').format(format);
            toDate = moment(maxDate).endOf('month').format(format);
        }
        return {
            fromDate,
            toDate
        };
    };

    render() {
        const {
            project,
            report,
            projectId,
            highlightLine,
            getLogImage,
            environment,
            index,
            selectedPlatform,
            reports,
            features
        } = this.props;

        const hasFilterByPhrases = this.props.hasFilterByPhrases();

        const filterProps = {
            projectId: projectId,
            project: project,
            report: report,
            reports: reports,
            settings: this.props.settings,
            index: this.props.index,
            filtersExpanded: this.props.filtersExpanded,
            toggleFilters: this.props.toggleFilters,
            toggleReportSection: this.props.toggleReportSection,
            environment: environment
        };

        return <div className="analytics-column">
            <AnalyticsFilter
                {...filterProps}
                canBeRenamed={true}
                canBeDeleted={true} />

            {isVoiceInteractionsChartAvailable(features) &&
                <AnalyticsVoiceInteractionsBarChartTile
                    sectionName="voiceInteractions"
                    {...filterProps} />}


            {isSessionsChartAvailable(features) &&
                <AnalyticsUserSessionsBarChartTile
                    sectionName="userSessions"
                    {...filterProps} />}

            {isLocationChartAvailable(features) && <AnalyticsLocationTile
                sectionName="locations"
                {...filterProps} />}


            <AnalyticUsersTile
                sectionName="users"
                selectedUserId={this.props.selectedUserId}
                selectedPlatform={selectedPlatform}
                selectUser={this.props.selectUser}
                {...filterProps}
            />
            <AnalyticDialogsTile
                sectionName="dialogs"
                selectedUserId={this.props.selectedUserId}
                selectedDialogId={this.props.logFilters[DIALOG_FILTER]}
                selectDialog={this.props.selectDialogFilterFromDialogTile}
                resetUserFilter={this.props.resetUserFilter}
                {...filterProps}
            />

            <AnalyticIntentsTile
                sectionName="intents"
                project={project}
                getLogImage={getLogImage}
                filters={this.props.logFilters}
                selectedDialogId={this.props.selectedDialogId}
                selectedPatternId={this.props.selectedPatternId}
                setFilterCb={this.props.setFilter}
                highlightLine={highlightLine}
                hasFilterByPhrases={hasFilterByPhrases}
                resetAllPhrasesFilters={this.props.resetAllPhrasesFilters}
                resetPatternFilter={this.props.resetPatternFilter}
                resetPhraseTextFilter={this.props.resetPhraseTextFilter}
                resetEntityFilter={this.props.resetEntityFilter}
                resetDialogFilter={this.props.resetDialogFilter}
                {...filterProps} />

            {/* <AnalyticPatternTile
                sectionName="patterns"
                selectedPatternHash={this.props.logFilters[PATTERNHASH_FILTER]}
                selectedPatternId={this.props.selectedPatternId}
                selectPattern={this.props.selectPattern}
                project={project}
                highlightLine={highlightLine}
                {...filterProps} /> */}

            {/* <AnalyticPatternFlowTile
                sectionName="patternFlows"
                selectPattern={this.props.selectPattern}
                selectedPattern={this.props.selectedPattern}
                requestPaternFlowsWithEvents={this.props.requestPaternFlowsWithEvents}
                {...filterProps} /> */}
        </div>;
    }
}

function mapStateToProps({ projectsInfo }, ownProps) {

    return {
    };
}


function mapDispatchToProps(dispatch) {
    return {
        updateReportDataByDialogs: (param) => asyncDispatch(actions.updateReportDataByDialogs, dispatch, param),
        updateIntentsInDataReport: (param) => asyncDispatch(actions.updateIntentsInDataReport, dispatch, param),
        toggleReportSection: (param) => asyncDispatch(actions.toggleReportSection, dispatch, param),
        toggleShowEventsFilterForPatternFlow: (param) => asyncDispatch(actions.toggleShowEventsFilterForPatternFlow, dispatch, param),
        getLogImage: (param) => asyncDispatch(projectActions.getLogImage, dispatch, param),
        highlightLine: (param) => dispatch(scriptEditorActions.highlightLine(param)),
    };
}


function withDialogFilters(WrappedComponent) {
    return class extends React.Component {
        constructor(props, context) {
            super(props, context);
            this.state = {
                logFilters: {
                    [INPUT_PHRASES]: true,
                    [OUTPUT_PHRASES]: true,
                    [UNRECOGNIZED_PHRASES]: true,
                    [PHRASE_FILTER]: null,
                    [PATTERNHASH_FILTER]: null,
                    [DIALOG_FILTER]: null,
                    [ENTITIES]: [],
                },
                selectedUserId: null,
                selectedDialogId: null, // only for visual highlighting
                selectedPatternId: null, // only for visual highlighting
            };
        }

        selectUser = (userId, userPlatform) => {
            this.setState({
                selectedUserId: userId,
                selectedPlatform: userPlatform
            }, () => {
                this.getIntents();
            });
        }

        resetUserFilter = () => {
            this.setState({ selectedUserId: null, selectedPlatform: null });
        }

        selectDialogFilterFromDialogTile = (dialogId) => {
            const { logFilters } = this.state;
            const { projectId, report, environment } = this.props;
            logFilters[DIALOG_FILTER] = dialogId;
            this.setState({ selectedDialogId: dialogId }, () => {
                this.props.updateReportDataByDialogs({
                    dialogIds: this.getSelectedDialogIds(),
                    projectId,
                    report,
                    environment,
                    filters: logFilters

                });
            });
        }

        requestPaternFlowsWithEvents = (report, onlyPatternOnPatternFlow) => {
            const {
                projectId,
                environment,
                toggleShowEventsFilterForPatternFlow
            } = this.props;
            toggleShowEventsFilterForPatternFlow({
                dialogIds: this.getSelectedDialogIds(),
                projectId,
                reportName: report.name,
                onlyPatternOnPatternFlow,
                environment,
            });
        }

        selectPattern = (patternHash, patternId, patternText) => {
            const { selectedPattern } = this.state;
            const { patterns } = this.props.report.data || {};
            if (selectedPattern?.pattern === patternText) {
                patternHash = null;
                patternId = null;
                patternText = null;
            }
            if ("Unrecognized" === patternText) { //TODO make a constant
                this.setFilter(UNRECOGNIZED_PHRASES, true);
                this.setFilter(INPUT_PHRASES, false);
                this.setFilter(OUTPUT_PHRASES, false);
            }
            //temporary
            if (patternHash == null && patternText != null && patterns) {
                const patternHashArr = patterns
                    .filter(p => p.pattern === patternText)
                    .map(p => p.patternHash);
                if (patternHashArr.length) {
                    patternHash = patternHashArr[0];
                }
            }
            if (patternId == null && patternHash != null && patternText != null && patterns) {
                const patternIdArr = patterns
                    .filter(p => p.patternHash === patternHash && p.pattern === patternText)
                    .map(p => p.id);
                if (patternIdArr.length) {
                    patternId = patternIdArr[0];
                }
            }
            let pattern = null;
            if (patternId != null) {
                pattern = patterns.filter(p => p.id === patternId)[0];
            }
            const { logFilters } = this.state;
            logFilters[PATTERNHASH_FILTER] = patternHash;
            logFilters[PATTERN_FILTER] = patternText;
            this.setState({ selectedPatternId: patternId, selectedPattern: pattern });
            this.updateFiltersStatesAfterReset(logFilters);
        }

        updateFiltersStatesAfterReset = (logFilters) => {
            this.setState({
                logFilters: logFilters,
                lastTs: 0,
                filterUpdateTs: Date.now()
            }, () => {
                this.getIntents();
            });
        }

        getIntents = () => {
            const { projectId, report, environment } = this.props;
            const { logFilters } = this.state;
            this.props.updateIntentsInDataReport({
                dialogIds: this.getSelectedDialogIds(),
                projectId,
                report,
                environment,
                filters: logFilters
            });
        }

        hasFilterByPhrases = () => {
            const { logFilters } = this.state;
            return !!logFilters[PHRASE_FILTER] || !!logFilters[PATTERNHASH_FILTER] || !!logFilters[PATTERN_FILTER] || !!logFilters[DIALOG_FILTER] || logFilters.entities.length > 0;
        };

        getSelectedDialogIds = () => {
            const { users } = this.props;
            const { logFilters, selectedUserId } = this.state;
            let dialogIds = [];
            if (logFilters[DIALOG_FILTER]) {
                dialogIds = [logFilters[DIALOG_FILTER]];
            } else if (selectedUserId) {
                const selectedUser = _.find(users, { uuid: selectedUserId });
                if (selectedUser) {
                    dialogIds = selectedUser.dialogs.map(dialog => dialog.id);
                }
            }
            return dialogIds;
        };

        setFilter = (filterName, filterValue, e) => {
            let curFilters = { ...this.state.logFilters };

            if (filterName === PHRASE_FILTER || filterName === PATTERNHASH_FILTER || filterName === DIALOG_FILTER) {
                curFilters[filterName] = filterValue;
            } else if (filterName === ENTITY_TYPE_FILTER || filterName === ENTITY_VALUE_FILTER) {
                const hasEntity = !!_.find(curFilters.entities, { [filterName]: filterValue });
                if (!hasEntity) {
                    curFilters.entities.push({ [filterName]: filterValue });
                }
            } else {
                if (filterValue != null) {
                    curFilters[filterName] = filterValue;
                } else {
                    curFilters[filterName] = e ? !curFilters[filterName] : true;
                }
            }

            this.updateFiltersStatesAfterReset(curFilters);
        }

        resetAllPhrasesFilters = () => {
            const { logFilters } = this.state;
            this.resetPatternFilter();
            this.resetPhraseTextFilter();
            this.resetDialogFilter();
            logFilters.entities = [];
            this.updateFiltersStatesAfterReset(logFilters);
        }

        resetPatternFilter = () => {
            const { logFilters } = this.state;
            logFilters[PATTERNHASH_FILTER] = null;
            this.setState({
                selectedPatternId: null,
                selectedPatternHash: null
            });
            this.updateFiltersStatesAfterReset(logFilters);
            this.selectPattern();
        }

        resetPhraseTextFilter = () => {
            const { logFilters } = this.state;
            logFilters[PHRASE_FILTER] = null;
            this.updateFiltersStatesAfterReset(logFilters);
        }

        resetEntityFilter = (entity) => {
            const { logFilters } = this.state;
            const entityInd = _.findIndex(logFilters.entities, entity);
            logFilters.entities.splice(entityInd, 1);
            this.updateFiltersStatesAfterReset(logFilters);
        }

        resetDialogFilter = () => {
            const { logFilters } = this.state;
            logFilters[DIALOG_FILTER] = null;
            this.setState({
                selectedDialogId: null
            });
            this.updateFiltersStatesAfterReset(logFilters);
        }

        render() {
            return <WrappedComponent
                selectUser={this.selectUser}
                resetUserFilter={this.resetUserFilter}
                selectDialogFilterFromDialogTile={this.selectDialogFilterFromDialogTile}
                selectPattern={this.selectPattern}
                hasFilterByPhrases={this.hasFilterByPhrases}
                setFilter={this.setFilter}
                resetAllPhrasesFilters={this.resetAllPhrasesFilters}
                resetPatternFilter={this.resetPatternFilter}
                resetPhraseTextFilter={this.resetPhraseTextFilter}
                resetEntityFilter={this.resetEntityFilter}
                resetDialogFilter={this.resetDialogFilter}
                requestPaternFlowsWithEvents={this.requestPaternFlowsWithEvents}
                {...this.state}
                {...this.props} />;
        }
    };
}

export const AnalyticColumn = connect(mapStateToProps, mapDispatchToProps)(withDialogFilters(AnalyticColumnComponent));
